import { useState, useEffect } from 'react'
import { Card, Table, Tag, Statistic, Row, Col } from 'antd'
import { DollarOutlined } from '@ant-design/icons'
import { financeApi } from '../../services/api'

export default function ExpenseRecords() {
  const [records, setRecords] = useState<any[]>([])
  const [stats, setStats] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 })

  useEffect(() => { loadRecords() }, [])

  const loadRecords = async (page = 1) => {
    setLoading(true)
    try {
      const params: any = { page, page_size: pagination.pageSize }
      const [recordsRes, statsRes] = await Promise.all([
        financeApi.getExpenseRecords(params),
        financeApi.getExpenseStats(params)
      ])
      // axios interceptor already unwraps response.data, so recordsRes = {success, data, total}
      const recordsData = recordsRes.data || recordsRes
      setRecords(Array.isArray(recordsData) ? recordsData : [])
      setPagination(prev => ({ ...prev, current: page, total: (recordsRes as any).total || 0 }))
      const statsData = statsRes.data || statsRes
      setStats(statsData || {})
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const recordTypeMap: Record<number, string> = { 1: '收入', 2: '支出' }
  const categoryMap: Record<number, string> = { 1: '销售收入', 2: '采购成本', 3: '人工成本', 4: '配送费用', 5: '租金水电', 11: '储值充值' }
  const paymentMethodMap: Record<number, string> = { 1: '银行转账', 2: '微信支付', 3: '支付宝', 4: '储值卡', 5: '微信支付', 6: '支付宝' }

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '编号', dataIndex: 'record_number', width: 140 },
    { title: '类型', dataIndex: 'record_type', width: 80, render: (v: number) => <Tag color={v === 1 ? 'green' : 'red'}>{recordTypeMap[v] || '未知'}</Tag> },
    { title: '分类', dataIndex: 'expense_category', width: 100, render: (v: number) => categoryMap[v] || v },
    { title: '金额', dataIndex: 'amount', width: 120, render: (v: number) => <span style={{ fontWeight: 600 }}>¥{Number(v || 0).toFixed(2)}</span> },
    { title: '支付方式', dataIndex: 'payment_method', width: 100, render: (v: number) => paymentMethodMap[v] || '-' },
    { title: '付款方', dataIndex: 'payer_name', width: 120, render: (v: string) => v || '-' },
    { title: '日期', dataIndex: 'transaction_date', width: 110 },
    { title: '描述', dataIndex: 'description', ellipsis: true }
  ]

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8}><Card size="small"><Statistic title="总收入" value={stats.totalIncome || 0} precision={2} prefix="¥" valueStyle={{ color: '#52c41a' }} /></Card></Col>
        <Col span={8}><Card size="small"><Statistic title="总支出" value={stats.totalExpense || 0} precision={2} prefix="¥" valueStyle={{ color: '#ff4d4f' }} /></Card></Col>
        <Col span={8}><Card size="small"><Statistic title="净利润" value={stats.netProfit || 0} precision={2} prefix="¥" /></Card></Col>
      </Row>

      <Card title={<span><DollarOutlined /> 收支记录</span>}>
        <Table
          columns={columns}
          dataSource={records}
          rowKey="id"
          loading={loading}
          pagination={{ ...pagination, onChange: (page) => loadRecords(page) }}
          size="middle"
        />
      </Card>
    </div>
  )
}
